<footer>
    <div *transloco="let t" class="w-screen bg-[#182A43] open-sans relative" id="target">

        <div class="px-2.5 md:px-10 flex items-end place-content-between lg:max-w-[1080px] mx-auto py-10">
            <div>
                <div class="text-white text-[20px] font-bold">{{t('routes.who.menu')}}</div>
                <div class="text-white mt-2 text-[20px] font-bold">{{t('routes.privacy.menu')}}</div>
                <div class="text-white mt-2 text-[20px] font-bold">{{t('routes.legalInfo.menu')}}</div>
                <div class="text-white mt-2 text-[20px] font-bold">{{t('routes.contacts.menu')}}</div>
            </div>
            <div class="relative"> 
                <img class="h-[250px] absolute left-[0px] bottom-[80px] z-[1]"
                    src="../assets/punti_interrog.svg">
                <!-- <img class="h-[250px] absolute left-[50px] bottom-[50px] rotate-[-10deg] z-[3]"
                    src="../assets/logoIcon.png">
                    <img class="h-[250px] absolute left-[30px] bottom-[180px] rotate-[45deg] z-[2]"
                    src="../assets/logoIcon.png">
                    <img class="h-[250px] absolute left-[-70px] bottom-[80px] rotate-[20deg] z-[1]"
                    src="../assets/logoIcon.png"> -->
                <img class="w-[250px]" src="../assets/logo.png">
            </div>
        </div>
        <div class="w-fit mx-auto text-white pt-5 pb-10">{{t('copyright')}}</div>
    </div>
</footer>